import React from 'react'
import PropTypes from 'prop-types'
import {
  LinkSecondary,
  TitleSecondary,
  ParagraphSecondary,
  SpacerVertical
} from 'mage-deps/@klarna/bubble-ui'
import { Message } from 'mage-i18n'
import { useEducationAnalytics } from 'education-tools'

PhoneContact.propTypes = {
  articleId: PropTypes.string,
  phoneNumbers: PropTypes.arrayOf(PropTypes.string).isRequired
}

function PhoneContact({ articleId, phoneNumbers }) {
  const commonTrackingData = {
    category: 'uhqm/contact',
    referenceType: articleId ? 'article' : undefined,
    referenceId: articleId,
    label: 'phone'
  }
  useEducationAnalytics({
    ...commonTrackingData,
    action: 'print',
    tackOnMount: true,
    googleAnalytics: false
  })
  const trackClick = useEducationAnalytics({ ...commonTrackingData, action: 'click' })

  return (
    <>
      <TitleSecondary>
        <Message path="hqm.contact.phone.title" fallback="Call us" />
      </TitleSecondary>

      <ParagraphSecondary>
        <Message
          path="hqm.contact.phone.paragraph"
          fallback="You can give us a call during business hours on weekdays. If you're located in Sweden or the United Kingdom, you can also call us on the weekend between 10am-4pm.  "
        />
      </ParagraphSecondary>

      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {phoneNumbers.map(phoneNumber => (
          <LinkSecondary
            key={phoneNumber}
            size="medium"
            href={`tel:${phoneNumber}`}
            onClick={() => trackClick()}
          >
            {phoneNumber}
          </LinkSecondary>
        ))}
      </div>

      <SpacerVertical large />
    </>
  )
}

export default PhoneContact
